/*
 * Русский перевод остальных страниц: API, главная Backstage (виджеты), граф каталога,
 * регистрация существующего компонента, вкладка Kubernetes.
 */
import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { apiDocsTranslationRef } from '@backstage/plugin-api-docs';
import { homeTranslationRef } from '@backstage/plugin-home';
import { catalogGraphTranslationRef } from '@backstage/plugin-catalog-graph';
import { catalogImportTranslationRef } from '@backstage/plugin-catalog-import';
import { kubernetesReactTranslationRef } from '@backstage/plugin-kubernetes-react';

const apiDocsRu = createTranslationMessages({
  ref: apiDocsTranslationRef,
  full: false,
  messages: {
    'apiDefinitionCard.error.title': 'Не удалось загрузить API',
    'apiDefinitionCard.rawButtonTitle': 'Исходник',
    'apiDefinitionDialog.closeButtonTitle': 'Закрыть',
    'apiDefinitionDialog.tabsAriaLabel': 'Представления определения API',
    'apiDefinitionDialog.toggleButtonAriaLabel': 'Открыть определение API',
    'apiDefinitionDialog.rawButtonTitle': 'Исходник',
    'defaultApiExplorerPage.title': 'API',
    'defaultApiExplorerPage.subtitle': 'API платформы {{orgName}}',
    'defaultApiExplorerPage.pageTitleOverride': 'API',
    'defaultApiExplorerPage.createButtonTitle': 'Зарегистрировать API',
    'defaultApiExplorerPage.supportButtonTitle': 'Все API платформы',
    'consumedApisCard.title': 'Используемые API',
    'consumedApisCard.error.title': 'Не удалось загрузить API',
    'consumedApisCard.emptyContent.title': '{{entity}} не использует API.',
    'hasApisCard.title': 'API',
    'hasApisCard.error.title': 'Не удалось загрузить API',
    'hasApisCard.emptyContent.title': '{{entity}} не содержит API.',
    'providedApisCard.title': 'Предоставляемые API',
    'providedApisCard.error.title': 'Не удалось загрузить API',
    'providedApisCard.emptyContent.title': '{{entity}} не предоставляет API.',
    'apiEntityColumns.typeTitle': 'Тип',
    'apiEntityColumns.apiDefinitionTitle': 'Определение API',
    'consumingComponentsCard.title': 'Потребители',
    'consumingComponentsCard.error.title': 'Не удалось загрузить компоненты',
    'consumingComponentsCard.emptyContent.title':
      'Ни один компонент не использует этот API.',
    'providingComponentsCard.title': 'Поставщики',
    'providingComponentsCard.error.title': 'Не удалось загрузить компоненты',
    'providingComponentsCard.emptyContent.title':
      'Ни один компонент не предоставляет этот API.',
    apisCardHelpLinkTitle: 'Как это изменить',
  },
});

const homeRu = createTranslationMessages({
  ref: homeTranslationRef,
  full: false,
  messages: {
    'addWidgetDialog.title': 'Добавить виджет на панель',
    'addWidgetDialog.noAvailableWidgets':
      'Все доступные виджеты уже добавлены.',
    'customHomepageButtons.edit': 'Редактировать',
    'customHomepageButtons.restoreDefaults': 'Вернуть по умолчанию',
    'customHomepageButtons.clearAll': 'Очистить',
    'customHomepageButtons.addWidget': 'Добавить виджет',
    'customHomepageButtons.save': 'Сохранить',
    'customHomepageButtons.cancel': 'Отмена',
    'customHomepage.noWidgets':
      'Виджетов нет. Нажмите «Добавить виджет», чтобы начать.',
    'widgetSettingsOverlay.editSettingsTooltip': 'Настройки',
    'widgetSettingsOverlay.editSettingsTooptip': 'Настройки',
    'widgetSettingsOverlay.deleteWidgetTooltip': 'Удалить виджет',
    'widgetSettingsOverlay.submitButtonTitle': 'Применить',
    'widgetSettingsOverlay.cancelButtonTitle': 'Отмена',
    'starredEntityListItem.removeFavoriteEntityTitle': 'Убрать из избранного',
    'visitList.empty.title': 'Посещений пока нет.',
    'visitList.empty.description':
      'Здесь появятся посещённые страницы — чтобы быстро вернуться к работе.',
    'visitList.few.title':
      'Чем больше страниц вы посетите, тем больше их появится здесь.',
    'visitList.disabled.title': 'Учёт посещений выключен.',
    'visitList.disabled.description':
      'Включите учёт посещений в app-config.yaml, чтобы видеть здесь частые и недавние страницы.',
    'quickStart.title': 'Первые шаги',
    'quickStart.description': 'Как начать работу с платформой',
    'quickStart.learnMoreLinkTitle': 'Подробнее',
    'starredEntities.noStarredEntitiesMessage':
      'Нажмите звёздочку рядом с именем сущности, чтобы добавить её сюда.',
    'visitedByType.action.viewMore': 'Показать больше',
    'visitedByType.action.viewLess': 'Показать меньше',
    'featuredDocsCard.learnMoreTitle': 'ПОДРОБНЕЕ',
    'featuredDocsCard.empty.title': 'Документов нет',
    'featuredDocsCard.empty.description':
      'Добавьте документацию в свой проект — как это сделать, описано в руководстве',
    'featuredDocsCard.empty.learnMoreLinkTitle': 'РУКОВОДСТВО',
  },
});

const catalogGraphRu = createTranslationMessages({
  ref: catalogGraphTranslationRef,
  full: false,
  messages: {
    'catalogGraphCard.title': 'Связи',
    'catalogGraphCard.deepLinkTitle': 'Открыть граф',
    'catalogGraphPage.title': 'Граф каталога',
    'catalogGraphPage.filterToggleButtonTitle': 'Фильтры',
    'catalogGraphPage.supportButtonDescription':
      'Добавьте компонент в каталог, чтобы он появился на графе.',
    'catalogGraphPage.simplifiedSwitchLabel': 'Упрощённый',
    'catalogGraphPage.mergeRelationsSwitchLabel': 'Объединять связи',
    'catalogGraphPage.zoomOutDescription':
      'Масштабируйте и перемещайте граф жестами. Клик — сменить активный узел, Shift+клик — открыть сущность.',
    'catalogGraphPage.curveFilter.title': 'Кривая',
    'catalogGraphPage.curveFilter.curveMonotoneX': 'Плавная',
    'catalogGraphPage.curveFilter.curveStepBefore': 'Ступенчатая',
    'catalogGraphPage.directionFilter.title': 'Направление',
    'catalogGraphPage.directionFilter.leftToRight': 'Слева направо',
    'catalogGraphPage.directionFilter.rightToLeft': 'Справа налево',
    'catalogGraphPage.directionFilter.topToBottom': 'Сверху вниз',
    'catalogGraphPage.directionFilter.bottomToTop': 'Снизу вверх',
    'catalogGraphPage.maxDepthFilter.title': 'Глубина',
    'catalogGraphPage.maxDepthFilter.inputPlaceholder': '∞ без ограничения',
    'catalogGraphPage.maxDepthFilter.clearButtonAriaLabel': 'сбросить глубину',
    'catalogGraphPage.selectedKindsFilter.title': 'Виды',
    'catalogGraphPage.selectedRelationsFilter.title': 'Связи',
  },
});

const catalogImportRu = createTranslationMessages({
  ref: catalogImportTranslationRef,
  full: false,
  messages: {
    'buttons.back': 'Назад',
    'defaultImportPage.headerTitle': 'Регистрация существующего компонента',
    'defaultImportPage.contentHeaderTitle': 'Добавьте компонент в {{appTitle}}',
    'defaultImportPage.supportTitle':
      'Добавьте существующий компонент в каталог {{appTitle}}.',
    'importInfoCard.title': 'Регистрация существующего компонента',
    'importInfoCard.deepLinkTitle': 'Подробнее о каталоге',
    'importInfoCard.linkDescription':
      'Укажите URL репозитория с исходным кодом, чтобы добавить его в {{appTitle}}.',
    'importInfoCard.fileLinkTitle': 'Ссылка на файл сущности',
    'importInfoCard.examplePrefix': 'Например: ',
    'importInfoCard.fileLinkDescription':
      'Мастер разберёт файл, покажет сущности и добавит их в каталог {{appTitle}}.',
    'importInfoCard.githubIntegration.title': 'Ссылка на репозиторий',
    'importInfoCard.githubIntegration.label': 'только GitHub',
    'importInfoCard.exampleDescription':
      'Мастер найдёт все файлы {{catalogFilename}} в репозитории, покажет сущности и добавит их в каталог {{appTitle}}.',
    'importInfoCard.preparePullRequestDescription':
      'Если сущностей нет, мастер подготовит merge request с примером {{catalogFilename}}, и каталог {{appTitle}} подхватит сущности после его слияния.',
    'importStepper.singleLocation.title': 'Выбор локаций',
    'importStepper.singleLocation.description': 'Найдена 1 локация',
    'importStepper.multipleLocations.title': 'Выбор локаций',
    'importStepper.multipleLocations.description':
      'Найдено локаций: {{length, number}}',
    'importStepper.noLocation.title': 'Создание merge request',
    'importStepper.noLocation.createPr.detailsTitle': 'Параметры merge request',
    'importStepper.noLocation.createPr.titleLabel': 'Заголовок',
    'importStepper.noLocation.createPr.titlePlaceholder':
      'Добавить описания сущностей каталога',
    'importStepper.noLocation.createPr.bodyLabel': 'Описание',
    'importStepper.noLocation.createPr.bodyPlaceholder':
      'Текст с поддержкой Markdown',
    'importStepper.noLocation.createPr.configurationTitle':
      'Параметры сущности',
    'importStepper.noLocation.createPr.componentNameLabel':
      'Имя создаваемого компонента',
    'importStepper.noLocation.createPr.componentNamePlaceholder':
      'my-component',
    'importStepper.noLocation.createPr.ownerLoadingText': 'Загрузка групп…',
    'importStepper.noLocation.createPr.ownerHelperText':
      'Выберите владельца из списка или укажите ссылку на группу или пользователя',
    'importStepper.noLocation.createPr.ownerErrorHelperText':
      'обязательное поле',
    'importStepper.noLocation.createPr.ownerLabel': 'Владелец сущности',
    'importStepper.noLocation.createPr.ownerPlaceholder': 'my-group',
    'importStepper.noLocation.createPr.codeownersHelperText':
      'ВНИМАНИЕ: не сработает, если в целевой локации нет файла CODEOWNERS.',
    'importStepper.analyze.title': 'URL',
    'importStepper.prepare.title': 'Действия импорта',
    'importStepper.prepare.description': 'Необязательно',
    'importStepper.review.title': 'Проверка',
    'importStepper.finish.title': 'Готово',
    'stepFinishImportLocation.backButtonText': 'Зарегистрировать ещё',
    'stepFinishImportLocation.repository.title': 'Открыт merge request: ',
    'stepFinishImportLocation.repository.description':
      'Сущности будут импортированы после слияния merge request.',
    'stepFinishImportLocation.locations.new': 'В каталог добавлены сущности:',
    'stepFinishImportLocation.locations.existing':
      'Запущено обновление локаций:',
    'stepFinishImportLocation.locations.viewButtonText': 'Открыть компонент',
    'stepFinishImportLocation.locations.backButtonText': 'Зарегистрировать ещё',
    'stepInitAnalyzeUrl.error.repository':
      'Не удалось сформировать сущности для репозитория',
    'stepInitAnalyzeUrl.error.locations': 'В этой локации нет сущностей',
    'stepInitAnalyzeUrl.error.default':
      'Неизвестный результат анализа типа {{type}}. Обратитесь в поддержку.',
    'stepInitAnalyzeUrl.error.url':
      'Адрес должен начинаться с http:// или https://.',
    'stepInitAnalyzeUrl.urlHelperText':
      'Укажите полный путь к файлу сущности, чтобы добавить компонент',
    'stepInitAnalyzeUrl.nextButtonText': 'Проанализировать',
    'stepPrepareCreatePullRequest.description':
      'Вы указали репозиторий {{integrationType}}, но файл {{catalogFilename}} в нём не найден. Эта форма откроет merge request, который его создаст.',
    'stepPrepareCreatePullRequest.previewPr.title':
      'Предпросмотр merge request',
    'stepPrepareCreatePullRequest.previewPr.subheader': 'Новый merge request',
    'stepPrepareCreatePullRequest.previewCatalogInfo.title':
      'Предпросмотр сущностей',
    'stepPrepareCreatePullRequest.nextButtonText': 'Создать MR',
    'stepPrepareSelectLocations.locations.description':
      'Выберите одну или несколько локаций из репозитория:',
    'stepPrepareSelectLocations.locations.selectAll': 'Выбрать все',
    'stepPrepareSelectLocations.existingLocations.description':
      'Эти локации уже есть в каталоге:',
    'stepPrepareSelectLocations.nextButtonText': 'Проверить',
    'stepReviewLocation.prepareResult.title': 'Открыт merge request: ',
    'stepReviewLocation.prepareResult.description':
      'Локацию можно импортировать уже сейчас — {{appTitle}} подхватит сущности после слияния merge request.',
    'stepReviewLocation.catalog.exists': 'Эти локации уже есть в каталоге:',
    'stepReviewLocation.catalog.new': 'В каталог будут добавлены сущности:',
    'stepReviewLocation.refresh': 'Обновить',
    'stepReviewLocation.import': 'Импортировать',
  },
});

const kubernetesPlurals: Record<string, string> = {
  'cluster.pods_few': '{{count}} пода',
  'cluster.pods_many': '{{count}} подов',
  'cluster.podsWithErrors_few': '{{count}} пода с ошибками',
  'cluster.podsWithErrors_many': '{{count}} подов с ошибками',
  'pods.pods_few': '{{count}} пода',
  'pods.pods_many': '{{count}} подов',
};

const kubernetesRu = createTranslationMessages({
  ref: kubernetesReactTranslationRef,
  full: false,
  messages: {
    ...kubernetesPlurals,
    'cluster.label': 'Кластер',
    'cluster.pods': 'подов',
    'cluster.pods_one': '{{count}} под',
    'cluster.pods_other': '{{count}} подов',
    'cluster.podsWithErrors': 'подов с ошибками',
    'cluster.podsWithErrors_one': '{{count}} под с ошибками',
    'cluster.podsWithErrors_other': '{{count}} подов с ошибками',
    'cluster.noPodsWithErrors': 'Подов с ошибками нет',
    'podsTable.columns.id': 'ID',
    'podsTable.columns.name': 'имя',
    'podsTable.columns.phase': 'фаза',
    'podsTable.columns.status': 'состояние',
    'podsTable.columns.containersReady': 'контейнеры готовы',
    'podsTable.columns.totalRestarts': 'перезапусков',
    'podsTable.columns.cpuUsage': 'CPU, %',
    'podsTable.columns.memoryUsage': 'память, %',
    'podsTable.unknown': 'неизвестно',
    'podsTable.status.running': 'Работает',
    'podsTable.status.ok': 'OK',
    'errorPanel.title': 'Не удалось получить объекты Kubernetes',
    'errorPanel.message':
      'Часть ресурсов Kubernetes для сущности {{entityName}} получить не удалось, поэтому карточка ошибок может быть неполной.',
    'errorPanel.errorsLabel': 'Ошибки',
    'errorPanel.clusterLabel': 'Кластер',
    'errorPanel.clusterLabelValue': 'Кластер: {{cluster}}',
    'errorPanel.fetchError':
      'Ошибка обращения к Kubernetes: {{errorType}}, сообщение: {{message}}',
    'errorPanel.resourceError':
      "Ошибка получения ресурса Kubernetes '{{resourcePath}}': {{errorType}}, код {{statusCode}}",
    'fixDialog.helpButton': 'Справка',
    'fixDialog.title': '{{podName}} — {{errorType}}',
    'fixDialog.detectedError': 'Обнаруженная ошибка:',
    'fixDialog.causeExplanation': 'Причина:',
    'fixDialog.fix': 'Как исправить:',
    'fixDialog.crashLogs': 'Логи падения:',
    'fixDialog.events': 'События:',
    'fixDialog.openDocs': 'Открыть документацию',
    'fixDialog.ariaLabels.fixIssue': 'исправить',
    'fixDialog.ariaLabels.close': 'закрыть',
    'podDrawer.buttons.delete': 'Удалить под',
    'podDrawer.cpuRequests': 'Запрос CPU',
    'podDrawer.cpuLimits': 'Лимит CPU',
    'podDrawer.memoryRequests': 'Запрос памяти',
    'podDrawer.memoryLimits': 'Лимит памяти',
    'podDrawer.resourceUtilization': 'Использование ресурсов',
    'hpa.minReplicas': 'мин. реплик',
    'hpa.maxReplicas': 'макс. реплик',
    'hpa.replicasSummary': 'реплик: от {{min}} до {{max}}',
    'hpa.currentCpuUsage': 'текущая нагрузка CPU:',
    'hpa.currentCpuUsageLabel': 'текущая нагрузка CPU: {{value}}%',
    'hpa.targetCpuUsage': 'целевая нагрузка CPU:',
    'hpa.targetCpuUsageLabel': 'целевая нагрузка CPU: {{value}}%',
    'pods.pods_one': '{{count}} под',
    'pods.pods_other': '{{count}} подов',
    'errorReporting.title': 'Ошибки',
    'errorReporting.columns.cluster': 'кластер',
    'errorReporting.columns.namespace': 'namespace',
    'errorReporting.columns.kind': 'вид',
    'errorReporting.columns.name': 'имя',
    'errorReporting.columns.messages': 'сообщения',
    'podLogs.title': 'Логов нет',
    'podLogs.description': 'Контейнер ничего не вывел в логи',
    'podLogs.buttonText': 'Логи',
    'podLogs.buttonAriaLabel': 'открыть логи',
    'podLogs.titleTemplate':
      '{{podName}} — логи {{containerName}} в кластере {{clusterName}}',
    'podExecTerminal.buttonText': 'Терминал',
    'podExecTerminal.buttonAriaLabel': 'открыть терминал',
    'podExecTerminal.titleTemplate':
      '{{podName}} — терминал {{containerName}} в кластере {{clusterName}}',
    'events.noEventsFound': 'Событий нет',
    'events.eventTooltip': 'Событие {{eventType}}',
    'events.firstEvent': 'Первое событие {{timeAgo}} (всего: {{count}})',
    'kubernetesDrawer.closeDrawer': 'Закрыть панель',
    'kubernetesDrawer.yaml': 'YAML',
    'kubernetesDrawer.managedFields': 'Managed fields',
    'kubernetesDrawer.unknownName': 'без имени',
    'linkErrorPanel.title':
      'Не удалось собрать ссылку на панель управления Kubernetes',
    'linkErrorPanel.message':
      "Не удалось собрать ссылку на панель кластера «{{clusterName}}»: свойство dashboardApp равно '{{dashboardApp}}'.",
    'linkErrorPanel.errorsLabel': 'Ошибки:',
    'namespace.label': 'namespace:',
    'namespace.labelWithValue': 'namespace: {{namespace}}',
    'kubernetesDialog.closeAriaLabel': 'закрыть',
  },
});

export const toolsTranslations = [
  createTranslationResource({
    ref: apiDocsTranslationRef,
    translations: { ru: () => Promise.resolve({ default: apiDocsRu }) },
  }),
  createTranslationResource({
    ref: homeTranslationRef,
    translations: { ru: () => Promise.resolve({ default: homeRu }) },
  }),
  createTranslationResource({
    ref: catalogGraphTranslationRef,
    translations: { ru: () => Promise.resolve({ default: catalogGraphRu }) },
  }),
  createTranslationResource({
    ref: catalogImportTranslationRef,
    translations: { ru: () => Promise.resolve({ default: catalogImportRu }) },
  }),
  createTranslationResource({
    ref: kubernetesReactTranslationRef,
    translations: { ru: () => Promise.resolve({ default: kubernetesRu }) },
  }),
];
